import React, { useState } from "react";
import { GraphMenu } from "components/DataExplorationV2/GraphMenu";
import { GraphMenuSection } from "components/DataExplorationV2/GraphMenuSection";
import { SelectChartSection } from "components/DataExplorationV2/SelectChartSection";
import {
  ChartSubtype,
  ChartType
} from "components/DataExplorationV2/ChartSubtypes";

export interface ChartTypeMenuProps {
  chartType: ChartType;
  chartSubtype: ChartSubtype;
  onChangeSubtype: (subType: ChartSubtype) => void;
  onChangeChartType: (chartType: ChartType) => void;
}
export const ChartTypeMenu = ({
  chartType,
  chartSubtype,
  onChangeSubtype,
  onChangeChartType
}: ChartTypeMenuProps): JSX.Element => {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);

  const handleToggleSection = (sectionKey: string): void => {
    setExpandedSection(prevState =>
      prevState !== sectionKey ? sectionKey : null
    );
  };
  //Hidden until future development of Saved Charts feature.
  const showSavedCharts = false;

  return (
    <GraphMenu title="Chart Type">
      <SelectChartSection
        chartType={chartType}
        chartSubtype={chartSubtype}
        onChangeSubtype={onChangeSubtype}
        onChangeChartType={onChangeChartType}
      />
      {showSavedCharts && (
        <GraphMenuSection
          title="Saved Charts"
          expanded={expandedSection === "savedCharts"}
          onToggleExpanded={() => handleToggleSection("savedCharts")}
        >
          <p>Section 1 content</p>
        </GraphMenuSection>
      )}
    </GraphMenu>
  );
};
